import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { RememberService } from '../../../core/services/remember.service';

@Component({
  selector: 'tt-factoring-bunts',
  templateUrl: './factoring-bunts.component.html',
  styleUrls: ['./factoring-bunts.component.css']
})
export class FactoringBuntsComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public grid?: GridOptions;

    public companyButtons: FormButton[] = [{ id: 'erase', type: 'danger', icon: 'fa fa-eraser', onClick: () => this.clear('businessco_no') }];

    public creatingNewBunts = false;

    variableNames: Record<string, string> = {
        businessco_no: ''
    };

    constructor(private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService, private rememberService: RememberService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1954))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies('1');
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.setting.view_id).setLoadDataFunction({ method: this.setting.p2_datatask_keyno, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private rememberFunc(id: string) {
        Object.keys(this.variableNames).forEach(key => {
            this.variableNames[key] = 'w_factoringbunts' + '.' + key;
        });
        
        if (!this.variableNames[id]) return;
        if (!this.setting) return;

        let variableValue = null;

        switch (id) {
            case 'businessco_no':
                variableValue = this.setting[id];
                break;
            default:
                break;
        }
        
        return this.rememberService.remember(this.variableNames[id], variableValue);
    }

    public async createChanges() {
        if (!!this.setting) {
            try {
                this.creatingNewBunts = true;

                const response = (await this.datatask.Post(1957, this.setting))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadGrid();
                }
            } finally {
                this.creatingNewBunts = false;
            }
        }
    }

    private clear(id: string) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.setting.businessco_no = '99999';

                Promise.all([
                    this.rememberFunc('businessco_no')
                ]).then(() => {
                    this.loadGrid();
                    Promise.resolve();
                });
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    view_id: string;
    p2_datatask_keyno: number;
}
